<div class="lua-divider-horizontal"
  [ngClass]="{
    'size-s': size === 'small',
    'size-m': size === 'medium',
    'size-l': size === 'large'
  }">
    <div class="content"></div>
</div>
